module.exports = __webpack_public_path__ + "img/profile-pack-up.d992420a.svg";